import LinkedEntityPreview from './LinkedEntityPreview';

interface LinkedEntity {
    Id: string;
    WebLink: string;
    EntityType: string;
    EntitySubtype: string;
    DisplayName: string;
    Preview?: LinkedEntityPreview;
}

export default LinkedEntity;
export const EMAIL_ENTITY_TYPE = 'message';
export const DRAGGED_EMAIL_ENTITY_SUBTYPE = 'dragged_email';
